! function(ac) {
  
  ac(document).ready(function() {   
	 ab.init()
  });
  
  var ab = {
    drawerTimeout: null,
   
    init: function() {
      this.hideDrawer(),this.gridAddToCart(),this.prodAddToCart(),this.removeCartItem(),this.initWishlist(),this.initProductWishlist(),this.hideModal()
    }, 
    getURLParam: function(name){
    	var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    	
      	if(results==null)
        {
       		return null;
   	 	}
    	else {
      	 	return results[1] || 0;
    	}
	},
    gridAddToCart: function() {
      //ac(".btnCart").live("click",function(i) {
       ac(document).on("click",".btnCart",function(i) {
         
       	  i.preventDefault();
          if(poshecommerce.ajax_cart) {
            var att = ac(this).attr("id"),
            	//qty = ac(this).attr("rel");
                qty= ac(".currqty_"+att).val();
            var img = '';
            if(jQuery('#wishlist-products').length){
            	 img = jQuery(this).closest('tr').children('td.product-image').find('img');
             
            }
            else if(jQuery('.list-view').length){
            	jQuery(this).closest('li').find('.list-view-item__image-column').children().each(function () {
                       img = jQuery(this).find('.list-view-item__image'); // "this" is the current element in the loop
                });
            }
            else if(jQuery('#multi-addToCart').length){
              if(jQuery(this).closest('tr').hasClass('prd_variant')){
                //jQuery(this).closest('tr').children('td:eq(1)').find('.list-view-item__image-column').children().each(function () {
                       img = jQuery(this).closest('tr').children('td:eq(0)').find('img'); // "this" is the current element in the loop
                //});
              }
              else{
                jQuery(this).closest('tr').children('td:eq(0)').find('.list-view-item__image-column').children().each(function () {
                       img = jQuery(this).find('.list-view-item__image'); // "this" is the current element in the loop
                });
              }
            }
            else if(ac("#orderformpage").length){
              	var id = jQuery(this).attr('id');
                if(jQuery(this).closest('tr').hasClass('varitem_'+id)){
                   	img = jQuery(this).closest('tr').children('td:eq(2)').find('img'); // "this" is the current element in the loop

                }
              	else{
                	img = jQuery(this).closest('tr').children('td:eq(1)').find('img'); // "this" is the current element in the loop
                }
            }
            else{
            	 //img = jQuery(this).closest('.proHover').find('.grid-view-item__image');
                 if(jQuery(this).closest('.details-right').length){
                   img =  jQuery(this).closest('.details-right').parent().siblings( ".proHover" ).find('.grid-view-item__image');
                 }
                 else{
                   img = jQuery(this).closest('.proHover').find('.grid-view-item__image');
                 }
            }			
            //console.log(img);
			var product_hndle = ac("#product-actions-" + att + " input[name=product_hndle]").val();
            Shopify.Wishlist.removeProduct(product_hndle); 
            
            //ab.addinToCart(att, qty ,img  );
            if(qty == 0 || !ac.isNumeric(qty)) { 
              alert("Sorry! No Items added to Cart, Please enter Qty."); 
              ac(".currqty_"+att).val(0);
              
            } 
            else {
              ab.addinToCart(att, qty ,img  );
            }
          } else {
            
            ac(this).parent().submit();
          }
        return;
      });
    },
    prodAddToCart: function() {
     
      var cartBtn = ac(".product-btn-cart"),
      	  pName = ac("h1.product-single__title").text(),
          pImg = ac(".product-single__photo .product-featured-img").attr("src");
	  ac(document).on('click', '.posh-quick-shop .product-btn-cart', function(i) {
        
        if (i.preventDefault(), "disabled" != ac(this).attr("disabled"))
          if (poshecommerce.ajax_cart) {
            
              var att = ac(this).closest('#add_to_cart_form').find('.product-form__variants').val();
           
            var qty = ac(this).closest("#add_to_cart_form input[name=quantity]").val();
            	qty || (qty = 1);
         var test =   ac(this).closest('.addToBox').parent(".product-form").find("select[name='id']").attr('selected', true).val();
          
         	//var img = ac(".product-single__photo .product-featured-img");
            //if(ac('.product-hover-effect-6').length || ac('.product-hover-effect-1').length){
               var img = ac(this).closest('.proHover').find('.grid-view-item__image');
            //}
            ab.addinToCart(att, qty , img)
          } else {
            ac(".product-form").submit();
          }
         return !1
      });
      ac(cartBtn).on("click",function(i) {
      
          //console.log(ac(this).closest('#add_to_cart_form').find('.product-form__variants').val());
       
        if (i.preventDefault(), "disabled" != ac(this).attr("disabled"))
          if (poshecommerce.ajax_cart) {
           // var att = ac(this).closest('#add_to_cart_form').find('.product-form__variants').val();
 			//console.log(att);return false;
            //console.log(ac('[id*="productbanner"]').length);
           // console.log(ac(this).parents('[id*="productbanner"]'));
            if(ac(this).parents('[id*="productbanner"]').length || ac('[id*="productBanner"]').length || ac('.deal-product').length ){
              
              var att = ac(this).closest('#add_to_cart_form').find('.product-form__variants').val();
              
            }
            else{
            
            	var att = ac(".product-form select[name='id']").attr('selected', true).val()
            	att || (att = ac("#add_to_cart_form input[name=id]").val());
              	
            }
           // return false;
          //  console.log(att);
            
            var qty = ac(this).closest("#add_to_cart_form").find("input[name=quantity]").val();
            	qty || (qty = 1);
      
         var img = ac(".product-single__photo .product-featured-img");
            if(ac(this).closest('.deal-description').length){
              img = ac(this).closest('.deal-description').siblings('.deal-product');
           // console.log(img);return false;
            }
            
            if(ac(this).parents('#productBanner').length){
              
              var str = ac(this).parents('[id*="swatchBanner"]').attr('id');
              var sectionid = str.substr(str.indexOf("-") + 1);
              img = ac(this).parents('#productBanner').find('[id*="swatchBanner"]').find("#FeaturedImage-"+sectionid);
          
            }
            if(ac(this).parents('#product-banner-timer').length){
               var str = ac(this).parents('[id*="swatchBanner"]').attr('id');
             
              var sectionid = str.substr(str.indexOf("-") + 1);
              img = ac(this).parents('[id*="productbanner"]').find('[id*="swatchBanner"]').find("#FeaturedImage-"+sectionid);
        		
            }
           
           // console.log(img);return false;
            ab.addinToCart(att, qty , img)
          } else {
            ac(".product-form").submit();
          }
         return !1
      })
    },
    onCartUpdate: function(cart) {
      ac.getJSON('/cart.js', function(cart) {
       
        if(Currency.format == "money_format")
        {
          	if(poshecommerce.freeshipping){
              if(poshecommerce.aboveprice != '' ){
                var left = '';
                var leftPrice = '';
                var shippingStr='';
                var free_shipping = parseInt(poshecommerce.aboveprice * 100);
                if(cart.total_price >= free_shipping){
                  shippingStr = "Congratulations! You've got free shipping!";
                }
                else{
                     left = parseInt(free_shipping - cart.total_price);
                     leftPrice = Shopify.formatMoney(Currency.convert(left, Currency.default_curr, Currency.currentCurrency),Currency.moneyFormats[Currency.currentCurrency].money_format);
                     shippingStr = "Spend <span class=money>"+leftPrice+"</span> more to reach FREE SHIPPING! ";
                }
                ac('.freeShipping').empty();
                ac('.freeShipping').html(shippingStr);
              }
            }
      		ac('.cart__subtotal').html(Shopify.formatMoney(Currency.convert(cart.total_price, Currency.default_curr, Currency.currentCurrency),Currency.moneyFormats[Currency.currentCurrency].money_format));
        }
        else
        {
          if(poshecommerce.freeshipping){
              if(poshecommerce.aboveprice != '' ){
                var left = '';
                var leftPrice = '';
                var shippingStr='';
                var free_shipping = parseInt(poshecommerce.aboveprice * 100);
                if(cart.total_price >= free_shipping){
                  shippingStr = "Congratulations! You've got free shipping!";
                }
                else{
                     left = parseInt(free_shipping - cart.total_price);
                     leftPrice = Shopify.formatMoney(Currency.convert(left, Currency.default_curr, Currency.currentCurrency),Currency.moneyFormats[Currency.currentCurrency].money_format)+" "+Currency.currentCurrency;
                     shippingStr = "Spend <span class=money>"+leftPrice+"</span> more to reach FREE SHIPPING! ";
                }
                ac('.freeShipping').empty();
                ac('.freeShipping').html(shippingStr);
              }
           }
            ac('.cart__subtotal').html(Shopify.formatMoney(Currency.convert(cart.total_price, Currency.default_curr, Currency.currentCurrency),Currency.moneyFormats[Currency.currentCurrency].money_format)+" "+Currency.currentCurrency);
        }
        
	  });
	},
  	removeCartItem: function() {
  		ac('.cart__remove').on('click', function(i){
   	 			i.preventDefault();
    			var productId = parseInt(ac(this).attr('data-id'));
      			var params2 = {
   					type: 'POST',
    				url: '/cart/change.js',
    				data: 'quantity=0&id='+productId,
    				dataType: 'json',
    				success: function(cart) {
                      
                    //update mini cart  
                    CartJS.updateItemById(productId,0);
                      
      				ac('#cart_row_'+productId).remove();
                      
                     //update cart sub-total 
                     ab.onCartUpdate(cart);
           			
    				},
   					error: function(XMLHttpRequest, textStatus) {
      					Shopify.onError(XMLHttpRequest, textStatus);
    				}
  				};
     	jQuery.ajax(params2);  	
      });
    },
    showLoadingBox: function() {
		ac("body").addClass("loading");
	},
	hideLoadingBox: function() {
		ac("body").removeClass("loading");
    },
  	showDrawer: function(i) {
      ac(i).show(), ab.drawerTimeout = setTimeout(function() {
        ac(i).hide()
      }, 5e3)
    },
    hideDrawer: function() {
      ac(".continue-shopping, .modalOverly, .closeDrawer").click(function() {
        
        clearTimeout(ab.drawerTimeout), ac(this).closest(".modal").hide();
       
      }),
      ac(".modalOverly").click(function() {
        
        clearTimeout(ab.drawerTimeout), ac("#cartDrawer,#cartError").hide();
       
      }),
	  ac(document).click(function(e) {
  	    var $successDrawer = ac('#cartError');
  		var $t = e.target; 
        if (($successDrawer).is($t)){
           clearTimeout(ab.drawerTimeout), ac("#cartDrawer,#cartError").hide();
        }
      });
    },
    addinToCart: function(att, qty , img ) {
      /* Order Form Page Change */
      if(ac("#orderformpage").length){
      	ac("#orderformpage .qty-form .AddToCart").find("#"+att).val("Adding...");		
      }
      /* Ended here - 786 */
      CartJS.addItem(att, qty, {     
      }, {
          "success": function(data, textStatus, jqXHR){
			
           	 ab.hideLoadingBox();
              /* Order Form Page Change */
             if(ac("#orderformpage").length){
             	ac("#orderformpage .qty-form .AddToCart").find("#"+att).val("Thank You");
             	setTimeout(function() {
      		 		ac("#orderformpage .qty-form .AddToCart").find("#"+att).val("Add More...");
        	 	}, 300);
             }
      		 /* Ended here - 786 */
             if(ac('#flyToCart').length){
                   
        			//Scroll to top if cart icon is hidden on top   
             	//	setTimeout(function() {   
              		jQuery('html, body').animate({
            		'scrollTop' : jQuery(".cart_anchor").position().top
        			},900);  
                  //  }, 1000);
               
               		//Select item image and pass to the function
        			var itemImg = img;
                    poshecommerce.cartFly.flyToElement(jQuery(itemImg), jQuery('.cart_anchor'),'cart');
               
               		return false;
             }
             setTimeout(function() {               
                 if(ac("#list-modal-view").length ){                   
                   if(jQuery('#list-modal-view .modalError').length){
          				jQuery('.modalError').remove();
        		   }
                   
                   /* if(poshecommerce.freeshipping){
                      if(poshecommerce.aboveprice != '' ){
                        var left = '';
                        var leftPrice = '';
                        var shippingStr='';
                        var free_shipping = parseInt(poshecommerce.aboveprice * 100);
                        if(cart.total_price >= free_shipping){
                          shippingStr = "Congratulations! You've got free shipping!";
                        }
                        else{
                             left = parseInt(free_shipping - cart.total_price);
                             leftPrice = Shopify.formatMoney(Currency.convert(left, Currency.default_curr, Currency.currentCurrency),Currency.moneyFormats[Currency.currentCurrency].money_format)+" "+Currency.currentCurrency;
                             shippingStr = "Spend <span class=money>"+leftPrice+"</span> more to reach FREE SHIPPING! ";
                        }
                        ac('.freeShipping').empty();
                        ac('.freeShipping').html(shippingStr);
                      }
                   }*/
                  
                   // ac('.cart__subtotal').html(Shopify.formatMoney(Currency.convert(cart.total_price, Currency.default_curr, Currency.currentCurrency),Currency.moneyFormats[Currency.currentCurrency].money_format)+" "+Currency.currentCurrency);

                   ac("#list-modal-view").css("display","block");
                 }
                 if (ac('#drawer-menu01').length) {
                    if(jQuery('#drawer-menu01 .drawerError').length){
              				jQuery('.drawerError').remove();
            		}
                    poshecommerce.cartDrawer.showCartDrawer();
                 }
               	 
               }, 300);
              
            	if(ac("#pageLoad").length ){
                  window.location = "/cart";
                }
          },
          "error": function(jqXHR, textStatus, errorThrown){
            /* Order Form Page Change */
            if(ac("#orderformpage").length){
      			ac("#orderformpage .qty-form .AddToCart").find("#"+att).val("Add to Cart");
            }
            /* Ended here - 786 */
            
            var errormsg = JSON.parse(jqXHR.responseText).description;
            ab.hideLoadingBox(),
            ac(".error-message").text(errormsg), ab.showDrawer("#cartError");
          }
      });
    },
    closeDrawer: function() {
    	ac(".closeDrawer").click(function() {
          ab.hideLoading(), ab.hideDrawer();
        })
  	},
    /*** Added for Custom Wishlist ***/
    initWishlist: function() {
      // ac(".grid-view-item .btnWishlistAdded,.list-view .btnWishlistAdded").live("click",function(i) {
         ac(document).on("click",".grid-view-item .btnWishlistAdded,.list-view .btnWishlistAdded",function(i) {   
      		  i.preventDefault();
              var a = ac(this).parent();
              var o;
              var str = ac(this).attr("id");
              var res = str.split("_");
              var product_handle = res[1];
              var title_class,image_class;
              var view_value = ab.getURLParam('view');
         	  Shopify.Wishlist.StoreProduct(product_handle);
              ac(".loadingBox").hide();
         	  if(ac(".grid-view-item" ).length > 0)
              {
           		 title_class = ".grid-view-item__title";
                 image_class = ".grid-view-item__image";
               	 o = a.parents(".grid-view-item");
                	
           	  }
        	  if(ac(".list-view-items").length > 0)
       	 	  {
                   
                  title_class = ".list-view-item__title";
                  image_class = ".grid-view-item__image";
                  o = a.parents(".list-view");
               
       		  }
           	  if(ac('.product-hover-effect-2').length){
              	a.html('<a class="btn btnList wishlist" href="/pages/wish-list" title="Go to wishlist">Added in Wishlist<span class="tooltip">Already Added wish</span></a>');
              }
           	  else if(ac('.product-hover-effect-5').length){
                a.html('<a id="already_wishlist_kingawns-men-aviator-sunglasses" href="/pages/wish-list" class="btn btnList added" title="Already in your wishlist, Go to wishlist" style="display: inline-block;"><i class="icon far fa-heart"></i> <span class="tooltip">Already Added wish</span> </a>')
              }
           	  else if(ac('.product-hover-effect-3').length){
                a.html('<a id="already_wishlist_kingawns-aviator-sunglasses" href="/pages/wish-list" class="btn btnList added" title="Already in your wishlist, Go to wishlist" style="display: block;"><i class="icon far fa-heart"></i><span class="tooltip">Already Added wish</span></a>');
              }
           	  else if(ac('.product-hover-effect-1').length){
                a.html('<a id="already_wishlist_kingawns-voyager-sunglasses" href="/pages/wish-list" class="btn btnList added" title="Already in your wishlist, Go to wishlist" style="display: inline-block;"><i class="icon far fa-heart"></i>  <span class="tooltip">Already Added wish</span></a>');
              }
           	  else{
              	//a.html('<a class="btn btnList wishlist" href="/pages/wish-list" title="Go to wishlist"><i class="fa fa-heart-o" aria-hidden="true"></i> <span class="tooltip">Already Added wish</span></a>');
                a.html('<a id="already_wishlist_kingawns-voyager-sunglasses" href="/pages/wish-list" class="btn btnList added" title="Already in your wishlist, Go to wishlist" style="display: inline-block;"><i class="icon far fa-heart"></i>  <span class="tooltip">Already Added wish</span></a>');

              }
              var i = o.find(title_class).text(),
              n = o.find(image_class).attr("src");

              ab.hideLoadingBox(),
           	  ac("#successDrawer").find(".modal-prod-name").text(i),
              ac("#successDrawer").find(".modal-prod-img").attr("src", n),
              ac("#successDrawer").find(".wishlistTxt").show(),
              ab.showDrawer("#successDrawer");     
            })
        },
        initProductWishlist: function() {
          
            ac(".product-single__meta .btnWishlistAdded").click(function(i) {
              i.preventDefault(); 
              var str = ac(this).attr("id");
              var res = str.split("_"); 
              
              var product_handle = res[1];
              Shopify.Wishlist.StoreProduct(product_handle);
              var a = ac(this).parent();
              
              ac("#btnWishlistAdded_"+product_handle).remove();
              
              ac("#already_wishlist_"+product_handle).show();
              var section_id = ac(this).attr('data-identify');
            
              if(section_id){              
                var i = ac("#swatchBanner-"+section_id).find(".product-single__title").text(),
              	n = ac("#swatchBanner-"+section_id).find("img[id^='FeaturedImage-']").attr("src");
              }
              else{              
              	var i = ac(".product-single__title").text(),
              	n = ac("img[id^='FeaturedImage-']").attr("src");
              }
             /* if(ac(this).closest('.deal-description').length){
                   n = ac(this).closest('.deal-description').siblings('.deal-product').find('img').attr("src");
               
                }*/
              
              ac("#successDrawer").find(".modal-prod-name").text(i),
              ac("#successDrawer").find(".modal-prod-img").attr("src", n),
              ac("#successDrawer").find(".wishlistTxt").show(),
              ab.showDrawer("#successDrawer");    
            });
          	//ac(".wishlistOuter .btnWishlistAdded").click(function(i) {
            ac(document).on('click', '.wishlistOuter .btnWishlistAdded', function(i) {
              i.preventDefault(); 
             
              var str = ac(this).attr("id");
              var res = str.split("_"); 
              var product_handle = res[1];
              
              Shopify.Wishlist.StoreProduct(product_handle);
              var a = ac(this).parent();
              ac("#btnWishlistAdded_"+product_handle).remove();
             
              ac("#already_wishlist_"+product_handle).show();
              var i = ac(".product-single__title.qwp-name").text(),
              n = ac("img[id^='product-featured-image-quickview']").attr("src");
                if(ac(this).closest('.deal-description').length){
                   n = ac(this).closest('.deal-description').siblings('.deal-product').find('img').attr("src");
               
                }
              
              ac("#successDrawer").find(".modal-prod-name").text(i),
              ac("#successDrawer").find(".modal-prod-img").attr("src", n),
              ac("#successDrawer").find(".wishlistTxt").show(),
              ab.showDrawer("#successDrawer");   
            });
            ac(document).on('click', '.product-form__item .btnWishlistAdded', function(i) {
              i.preventDefault(); 
              var str = ac(this).attr("id");
              var res = str.split("_"); 
              var product_handle = res[1];
             
              Shopify.Wishlist.StoreProduct(product_handle);
              var a = ac(this).parent();
              ac("#btnWishlistAdded_"+product_handle).remove();
              var section_id = ac(this).attr('data-identify');
              var image = ac("*[data-section-id^='"+section_id+"']").find('.deal-product').find('img');
              //var image = ac(this).parents('.deal-description').siblings('.deal-product').find('img').attr("src");
              ac("#already_wishlist_"+product_handle).show();
              var i = ac("*[data-section-id^='"+section_id+"']").find('.deal-description').find('h2').text(),
              n = image.attr("src");
              
              ac("#successDrawer").find(".modal-prod-name").text(i);
              ac("#successDrawer").find(".modal-prod-img").attr("src", n);
              ac("#successDrawer").find(".wishlistTxt").show();                
              ab.showDrawer("#successDrawer");   
            });
        },
        hideLoading: function() {
            ac(".loadingBox").hide()
        },
    	hideModal: function() {
    	 ac(".continue-shopping").click(function() {
       	 	clearTimeout(ab.drawerTimeout), ac(this).closest(".modal").hide();
     	 }),
         ac(document).click(function(e) {
  		   var $successDrawer = ac('#successDrawer');
  		   var $t = e.target; 
           if (($successDrawer).is($t)){             
             clearTimeout(ab.drawerTimeout), ac(".modal").hide();
           }
         });
        } 
  }
}(jQuery);